import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TAny, TIdName } from "@app/lib/models/common.type";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { Observable } from "rxjs";
import { IAssignCourt, IAvaiableJudgeParams, ICaseItem, ICasePartyParams, ICaseSearchRequestBody, ICaseTrailCourt, ICaseTrailCourtRequestBody, ICourtDivisionParams, ICourtSessionPanel, ICourtSessionPanelParams, ICourtUnitType, IJudge, IJudgeStat, IJudgeStatBody, IPagination, ISearchRequestParams } from "../models/case-assignment.model";

@Injectable({
    providedIn: 'root'
})
export class CourtPanelAssignmentService extends BaseHttpService {

    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
    }

    /**
     * Search Case By case information
     * @param reqBody 
     * @param queryParams 
     * @returns 
     */
    searchCase(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams): Observable<IResponse<ICaseItem[]>> {
        return this.post<IResponse<ICaseItem[]>, ICaseSearchRequestBody>('case/search/by/case-number.htm', reqBody, { params: { ...queryParams } });
    }
    /**
     * Get trail court information
     * @param reqBody 
     * @returns 
     */
    getTrailCount(reqBody: ICaseTrailCourtRequestBody) {
        return this.post<IResponse<ICaseTrailCourt>, ICaseTrailCourtRequestBody>('case-phase/trail-courts.htm', reqBody);
    }

    /**
     * Divisions or Court rooms
     * @param queryParams 
     * @returns 
     */
    getDivisions(queryParams: ISearchRequestParams) {
        return this.get<IResponse<ICourtUnitType[]>>('court-unit-types/fetch.htm', { params: { ...queryParams } });
    }

    getCourtUnitByDivision(queryParams: ICourtDivisionParams) {
        return this.get<{ success: ICourtUnitType[] }>('court-panel/division/courts.htm', { params: { ...queryParams } });
    }

    getAvailableJudges(queryParams: IAvaiableJudgeParams) {
        return this.get<IResponse<IJudge[]>>('court-panel/court/available-judges.htm', { params: { ...queryParams } });
    }

    getJudgeStats(reqBody: IJudgeStatBody) {
        return this.post<IResponse<IJudgeStat[]>, IJudgeStatBody>('court-panel/judge/assignment/stats.htm', reqBody);
    }

    saveAssignJudge(reqBody: IAssignCourt) {
        return this.post<IResponse<any>, IAssignCourt>('court-panel/case/assignJudge.htm', reqBody);
    }

    assignPanel(reqBody: IAssignCourt): Observable<IResponse<any>> {
      return this.post<IResponse<any>, IAssignCourt>('court-panel/case/assignPanel.htm', reqBody);
    }

    getCourtSessions(queryParams: IPagination) {
        return this.get<IResponse<TIdName[]>>('court-panel/court/session.htm', { params: { ...queryParams } });
    }

    getPanels(queryParams: ICourtSessionPanelParams) {
        return this.get<IResponse<ICourtSessionPanel[]>>('court-panel/court/session/panels.htm', { params: { ...queryParams } });
    }

    getPanelJudges(reqBody: TAny, queryParams: ISearchRequestParams) {
        return this.post<IResponse<IJudge[]>, TAny>('court-panel/panel/judges/available.htm', reqBody, { params: { ...queryParams } });
    }

    getPartyDetails(queryParams: ICasePartyParams) {
        return this.get<IResponse<TAny>>('parties/by/case.htm', { params: { ...queryParams } })
    }

}